import React from "react"
import { useDispatch } from "react-redux"
import { PlayCircleFill } from "react-bootstrap-icons"
import { prependAndPlay } from "../../stores/mediaPlayerSlice"
import { HotBitsSongData } from "./HotBitsSong"
import styles from "./styles.module.css"

export interface HotWaxAlbumData {
  album_id: number
  album_name: string
  album_path: string
  band_id: number
  band_name: string
  band_path: string
  cover_image_small: string | null
  score: number
  song_count: number
  songs: HotBitsSongData[]
}

interface HotWaxAttrs {
  playlistId: number | null
  playlist_name: string
  playlist_path: string | null
}

interface Props {
  album: HotWaxAlbumData
  rank: number
  hotWaxAttrs: HotWaxAttrs
}

const recordHotWaxPageView = (albumId: number) => {
  const csrf = (document.querySelector("meta[name=csrf-token]") as HTMLMetaElement)?.content
  fetch("/api/v1/referral_conversions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
    },
    body: JSON.stringify({
      convertible_type: "Post",
      convertible_id: albumId,
      conversion_type: "page_view",
    }),
  })
}

const HotWaxAlbum = ({ album, rank, hotWaxAttrs }: Props) => {
  const dispatch = useDispatch()

  const onPlayClick = () => {
    dispatch(
      prependAndPlay(
        album.songs.map((song) => ({
          id: song.post_id,
          title: song.title,
          band_id: song.band_id,
          band_name: song.band_name,
          album_id: song.album_id,
          album_name: song.album_name,
          album_path: song.album_path,
          cover_image_small: song.cover_image_small,
          duration: song.duration,
          local_path: song.local_path,
          nada_path: song.nada_path,
          parent_path: song.nada_path,
          streaming_url: song.streaming_url,
          post_type: song.post_type,
          ...hotWaxAttrs,
        })),
      ),
    )
  }

  return (
    <div className={styles.row}>
      <span className={styles.rank}>{rank}</span>
      <div className={styles.songInfo}>
        <a
          href={album.album_path}
          className={styles.title}
          onClick={() => recordHotWaxPageView(album.album_id)}
        >
          {album.album_name}
        </a>
        <a href={album.band_path} className={styles.artist}>
          {album.band_name}
        </a>
      </div>
      <button
        onClick={onPlayClick}
        aria-label={`Play ${album.album_name}`}
        className={styles.playButton}
      >
        <PlayCircleFill size={22} />
      </button>
    </div>
  )
}

export default HotWaxAlbum
